import { render, staticRenderFns } from "./eRemitPayPaymentReview.vue?vue&type=template&id=702ed936&scoped=true&"
import script from "./eRemitPayPaymentReview.vue?vue&type=script&lang=js&"
export * from "./eRemitPayPaymentReview.vue?vue&type=script&lang=js&"
import style0 from "./eRemitPayPaymentReview.vue?vue&type=style&index=0&id=702ed936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ed936",
  null
  
)

export default component.exports